import React, { Component,Fragment } from 'react';

// component
import ToDoList from '../layout/todoList';
import AddContact from '../pages/addContact';

class Home extends Component {
  
  render() {
    return (
      <Fragment>
        <AddContact></AddContact>
        <ToDoList></ToDoList>
      </Fragment>
    )
  }
}

export default Home;
